'use client';

import { useEffect, useState } from 'react';
import { ArticleLoading } from '@ias/components/src/components/ArticleLoading';

const REDIRECT_KEY = 'sign_in_redirect';

export default function AuthCallback() {
  const [redirecting, setRedirecting] = useState(false);

  useEffect(() => {
    if (typeof window === 'undefined' || redirecting) return;

    const url = window.sessionStorage.getItem(REDIRECT_KEY);
    console.log('[AuthCallback] redirect URL from sessionStorage:', url);

    if (url) {
      console.log('[AuthCallback] Redirecting to:', url);
      setRedirecting(true);
      window.sessionStorage.removeItem(REDIRECT_KEY);
      window.location.href = url;
    } else {
      console.log('[AuthCallback] No redirect URL, going to /');
      setRedirecting(true);
      window.location.href = '/';
    }
  }, [redirecting]);

  return <ArticleLoading />;
}
